<template>
  <td class="main-td">
    <template v-if="currentSaleResult">

      <auction-results-sync-cell-table :item="currentSaleResult" :currency="currency" :is-current-state="false"/>

      <div class="checkbox-wrapper">
        <b-form-checkbox :checked="currentSaleResult.checked" size="lg" switch @change="onCheckedChange"/>
      </div>

    </template>
  </td>
</template>

<script>
  import AuctionResultsSyncCellTable from "@/modules/lots/auction-results-sync-modal/AuctionResultsSyncCellTable";

  export default {
    name: "AuctionResultsSyncCell",
    components: {AuctionResultsSyncCellTable},
    props: {
      saleResults: {
        type: Array
      },
      currency: {
        type: Object,
      },
      isCurrentState: {
        type: Boolean,
        default: true
      },
      liveProvider: {
        type: Object
      }
    },
    computed: {
      currentSaleResult() {
        let item = this.saleResults.find(i => i.third_party_provider_key === this.liveProvider.provider_key)
        if (!item) {
          return null
        }
        return item
      }
    },
    methods: {
      onCheckedChange(val) {
        this.currentSaleResult.checked = val

        if (val) {
          this.saleResults.forEach(saleResult => {
            if (saleResult.third_party_provider_key !== this.liveProvider.provider_key) {
              saleResult.checked = false
            }
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .main-td {
    padding-bottom: 2.5em;
    position: relative;

    .checkbox-wrapper {
      position: absolute;
      bottom: 1em;
    }
  }
</style>